import styled from "@emotion/styled";
import { useFormikContext } from "formik";
import type { ReactNode } from "react";

import { useFormatMessage } from "@skilitics/localization";

import { Button, ButtonGroup, PrimaryButton } from "../buttons/Buttons";
import { Loading } from "../common";

const LoadingContainer = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 10px;
  svg {
    transform-origin: center center;
  }
`;

const DestroyButtonContainer = styled.div`
  margin-right: auto;
`;

// this component is a convenience composite buttons component
// for cases where submitOnBlur is off (e.g. on create of a module or a variable)
const formatStrings = {
  submitLabel: {
    en: "Apply",
  },
  cancelLabel: {
    en: "Cancel",
  },
};

type Props = {
  alwaysShow?: boolean;
  cancelLabel?: string;
  applyLabel?: string;
  isLoading?: boolean;
  destroyButton?: ReactNode;
};

// TODO: tidy up inline styles, whitespace in layout
export const FormApplyOrCancel = ({ applyLabel, cancelLabel, alwaysShow, isLoading, destroyButton }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);
  const { dirty } = useFormikContext();
  if (!dirty && !alwaysShow) {
    return null;
  }
  return (
    <ButtonGroup $direction="horizontal" $align="flex-end" data-test="button-group-container">
      {destroyButton && <DestroyButtonContainer>{destroyButton}</DestroyButtonContainer>}
      <Button type="reset" data-test="cancel-button" disabled={isLoading}>
        {cancelLabel ?? formatMessage("cancelLabel")}
      </Button>
      <PrimaryButton type="submit" data-test="submit-button" disabled={isLoading}>
        {isLoading && (
          <LoadingContainer>
            <Loading />
          </LoadingContainer>
        )}
        {applyLabel ?? formatMessage("submitLabel")}
      </PrimaryButton>
    </ButtonGroup>
  );
};
